import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import * as z from 'zod';

import { ConfirmRegistrationPage } from '#modules/user/features/auth/pages/ConfirmRegistration';

export const Route = createFileRoute('/{-$locale}/_layout/confirm-registration')({
  validateSearch: zodValidator(
    z.object({
      token: z.string(),
    })
  ),
  component: ConfirmRegistrationPage,
  ssr: false,
});
